import { Icon } from '@iconify/react';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Dropdown, DropdownButton, OverlayTrigger, Tooltip } from 'react-bootstrap';
import overflowMenuHorizontal from '@iconify-icons/carbon/overflow-menu-horizontal';
import removeCircle from '@iconify-icons/el/remove-circle';
import ticketIcon from '@iconify-icons/entypo/ticket';
import { trackPromise } from 'react-promise-tracker';
import Swal from 'sweetalert2';
import { AtendimentoContext } from '../../../contexts/AtendimentoContext';
import caAPI from "../../../services/caAPI";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faListUl } from '@fortawesome/free-solid-svg-icons';
import { ModulosContext } from '../../../contexts/ModulosContext';
import ProcessosVinculados from './ProcessosVinculados';

export default function MenuDetalhes ({tipoDetalhes, titleToggle, handleSetClienteDadosProcesso, handleSetClienteDadosOpv, handleSelecionaProcesso, link, handleVincularChamado, idProcesso, openInputVincularChamado=null, idOpv=null}) {
  const { handleAtualizaLista,atendimentoAtivo, setIsOpenInformacoesAtendimento} = useContext(AtendimentoContext);
  const {possuiDesk} = useContext(ModulosContext);
  const [openListaProcessosVinculados, setOpenListaProcessosVinculados] = useState(false);
  const [openModalVincularProcesso, setOpenModalVincularProcesso] = useState(false);
  const [qtdProcessosAdicionais, setQtdProcessosAdicionais] = useState(0);
  const [processoVisualizado, setProcessoVisualizado] = useState(null);
  const desvincularProcessoExibidoRef = useRef(null);

  const registrarDesvincularProcesso = useCallback((fn) => {
    desvincularProcessoExibidoRef.current = fn;
  }, []);

  // Ao abrir/atualizar pelo fluxo normal (mudança do processo principal), volta a exibir o processo principal.
  useEffect(() => {
    setProcessoVisualizado(null);
  }, [idProcesso]);

  function handleVisualizarProcessoVinculado(dados, idProcessoClicado) {
    if (handleSetClienteDadosProcesso) {
      handleSetClienteDadosProcesso(Object.assign({}, dados, { id_processo_visualizado: idProcessoClicado }));
    }
    setProcessoVisualizado({
      idProcesso: idProcessoClicado,
      link: dados?.link_processo || null,
    });
  }

  const linkExibido = processoVisualizado ? processoVisualizado.link : link;
  const tituloExibido = processoVisualizado
    ? `Processo: ${String(processoVisualizado.idProcesso).padStart(5, '0')}`
    : titleToggle;

  function alteraProcesso() {
    Swal.fire({
      titleText: "Desvincular OPV/Processo do atendimento?",
      text: "Tem certeza que deseja desvincular essa OPV/Processo deste atendimento?",
      icon: 'question',
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Sim!',
      cancelButtonText: 'Não!',
      customClass: {
        confirmButton: 'btn btn-primary mr-3',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    }).then(
      (result) => {
        if (!result.value) {
          return;
        }
        if (tipoDetalhes === 'processo') {
          handleDesvincularProcessoExibido();
          return;
        }
        handleSetClienteDadosOpv(null);
        handleDesvincularOPVProcesso('oportunidade');
        handleSelecionaProcesso(null, tipoDetalhes);
        setIsOpenInformacoesAtendimento(false);
      }
    );
  }

  function handleDesvincularProcessoExibido() {
    const estaVisualizandoOutro = !!processoVisualizado;
    const idProcessoExibido = estaVisualizandoOutro ? processoVisualizado.idProcesso : idProcesso;
    if (!idProcessoExibido || !desvincularProcessoExibidoRef.current) {
      return;
    }
    trackPromise(
      desvincularProcessoExibidoRef.current(idProcessoExibido).then(() => {
        if (!estaVisualizandoOutro) {
          return;
        }
        setProcessoVisualizado(null);
        return caAPI.atendimento.processo.buscaPorId(idProcesso).then((res) => {
          if (handleSetClienteDadosProcesso) {
            handleSetClienteDadosProcesso(res.data);
          }
        });
      }).catch(() => {}),
      'loading-detalhes-processo'
    );
  }

    function handleDesvincularOPVProcesso(desvincular) {
        var data = {
            [desvincular]: null
        }
        caAPI.atendimento.update(data, atendimentoAtivo.id).then(()=>{
          handleAtualizaLista();
        }).catch(err => {
          handleAtualizaLista();
          console.log("err", err)
          Swal.fire({
              titleText: "Erro",
              text: "Erro ao Desvincular OPV/Processo",
              icon: 'error'
          });
      })
    }
    
    const tooltipHeader = useMemo(()=>{
      switch(tipoDetalhes){
        case 'processo':
          return 'Abrir Processo';
        case 'oportunidade':
          return 'Abrir Oportunidade';
        case 'chamado':
          return 'Chamados';
        default:
          return '';
      }
    },[tipoDetalhes])

    return <>
      <div className="numeroOPVProcesso" style={{display: 'flex', flexDirection: 'row', gap: '5px', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
          <OverlayTrigger key="abrirOpv" placement="top" overlay={<Tooltip id={`tooltip-abrir-opv`}>{tooltipHeader}</Tooltip>}>
            <div 
              className='text-dark' 
              style={{ cursor: 'pointer', textDecoration: 'underline' }} 
              onClick={() => {
                  if(linkExibido){
                    window.open(linkExibido, '_blank')
                  }
                }
              }
            >
              <div style={{display: 'flex', flexDirection: "row", gap: "10px", alignItems: "center"}}>
                {tipoDetalhes !== 'chamado' ?  <FontAwesomeIcon icon={faLink} color='#777' /> : <></>}
                {tituloExibido}
              </div>
            </div>
          </OverlayTrigger>
          {tipoDetalhes === 'processo' && idProcesso &&
            <OverlayTrigger key="processosVinculados" placement="top" overlay={<Tooltip id={`tooltip-processos-vinculados`}>Processos vinculados</Tooltip>}>
              <div
                style={{ position: 'relative', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                onClick={() => setOpenListaProcessosVinculados(true)}
              >
                <FontAwesomeIcon icon={faListUl} color='#265d9c' />
                {qtdProcessosAdicionais > 0 &&
                  <span
                    className="badge badge-danger"
                    style={{
                      position: 'absolute',
                      top: '-8px',
                      right: '-8px',
                      backgroundColor: '#ff5c58',
                      borderRadius: '9px',
                      width: '17px',
                      height: '17px',
                      fontSize: '12px',
                      color: '#fff',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {qtdProcessosAdicionais}
                  </span>
                }
              </div>
            </OverlayTrigger>
          }
        </div>
        {tipoDetalhes === 'chamado' && openInputVincularChamado && 
          <OverlayTrigger key="vincularChamado" placement="top" overlay={<Tooltip id={`tooltip-vincular-chamado`}>Vincular Chamado</Tooltip>}>
            <FontAwesomeIcon 
              icon={faLink} 
              color='#777' 
              className='mr-2'
              onClick={()=>{
                openInputVincularChamado()
              }}
            />
          </OverlayTrigger>
        }
      </div>
      <div className="menuOPVProcessos">
        <OverlayTrigger
          key="buttonMenuOPVProcessos"
          placement="top"
          overlay={
            <Tooltip id={`tooltip-editar`}>
              Menu
            </Tooltip>
          }
        >
          <DropdownButton
            id="DropOPVProcessos"
            size="sm"
            title={
            <Icon
                icon={overflowMenuHorizontal}
                width="2rem"
              />
            }>
            <Dropdown.Item className="opcaoMenu" disabled href="#/action-2">
              {"Abrir chamado "}
              <Icon icon={ticketIcon} className="" />
            </Dropdown.Item>
            {(idProcesso || idOpv)&& 
              <Dropdown.Item className="opcaoMenu" onClick={alteraProcesso}>
                {"Desvincular OPV/Processo "}
                <Icon
                  icon={removeCircle}
                  width="1rem"
                />
              </Dropdown.Item>
            }
            {tipoDetalhes === 'processo' && idProcesso &&
              <Dropdown.Item className="opcaoMenu" onClick={() => setOpenModalVincularProcesso(true)}>
                {"Vincular processo "}
                <FontAwesomeIcon
                  className='ml-2'
                  icon={faLink}
                />
              </Dropdown.Item>
            }
            {possuiDesk  && idProcesso ?
              <Dropdown.Item className="opcaoMenu" onClick={handleVincularChamado}>
                {"Vincular Chamado"}
                <FontAwesomeIcon
                  className='ml-2'
                  icon={faLink}
                />
              </Dropdown.Item>
            : <></>}
          </DropdownButton>
        </OverlayTrigger>
      </div>
      {tipoDetalhes === 'processo' &&
        <ProcessosVinculados
          openLista={openListaProcessosVinculados}
          setOpenLista={setOpenListaProcessosVinculados}
          openVincular={openModalVincularProcesso}
          setOpenVincular={setOpenModalVincularProcesso}
          onAtualizarContagem={setQtdProcessosAdicionais}
          onSelecionarProcessoVinculado={handleVisualizarProcessoVinculado}
          onRegistrarDesvincular={registrarDesvincularProcesso}
        />
      }
    </>
  }
